


































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { DirectiveBinding } from 'vue/types/options'

import CustomEditor from '../../logic/Editor/CustomEditor'
import FlowHelper from '../../logic/Helpers/helper'
import CustomNode from '../../logic/Nodes/CustomNode'
import OutputSocket from '../Socket/OutputSocket.vue'
import { SocketNames } from '../Socket/SocketsHelper'
import OutputConnectionStatValue from '../Statistics/OutputConnectionStatValue.vue'

@Component({
  components: {
    OutputConnectionStatValue
  },
  data() {
    return {
      SocketNames,
      FlowHelper,
      OutputSocket,
    }
  }
})
export default class ButtonView extends Vue {
  @Prop() bindSocket!: DirectiveBinding

  @Prop() node!: CustomNode

  @Prop() text!: string

  @Prop() output?: number

  @Prop() editor!: CustomEditor

  @Prop({ default: SocketNames.Default }) type!: SocketNames

  @Prop({ type: Boolean, default: true }) first!: boolean

  @Prop({ type: Boolean, default: true }) last!: boolean

  @Prop({ type: Boolean, default: false }) isSelect!: boolean

  get classes(): { [key: string]: boolean } {
    return {
      'rounded-tl': this.first,
      'rounded-bl': this.last,
      'animate-pulse': this.isSelect,
      'w-full': this.editor.isStatisticsViewSelected,
      'w-56': !this.editor.isStatisticsViewSelected
    }
  }

  get styles(): { [key: string]: string | number } {
    return {
      backgroundColor: `rgba(${ FlowHelper.typeSocketColor(this.type) }, 0.3)`,
      borderLeft: `2px solid rgba(${ FlowHelper.typeSocketColor(this.type) }, 0.7)`,
      borderBottom: `2px solid rgba(${ FlowHelper.typeSocketColor(this.type) }, 0.7)`,
      ...this.first ? { borderTop: `2px solid rgb(${ FlowHelper.typeSocketColor(this.type) })` } : {}
    }
  }

  get showStatistics() {
    if (this.customOutput) {
      return this.editor.isStatisticsViewSelected && this.customOutput.hasConnection() && this.customOutput.connections[0].data.statistics
    }

    return false
  }

  get customOutput() {
    if (this.output) {
      return Vue.observable(this.node.getOutput(this.output))
    }

    return undefined
  }
}
